import {Rule} from 'antd/lib/form';

export const rulesConsulAddress: Rule[] = [
    {
        required: true,
        message: 'Consul注册中心地址不能为空',
    },
];
